export default "__VITE_ASSET__DrRYlbYo__"